import React, { useEffect, useRef, useState } from "react";
import { Box, ButtonWithAction, KebabMenuIcon, Text } from "@thecb/components";
import { BORDER_PRIMARY, HOVER_GREY, TEXT_PRIMARY, WHITE } from "@/constants/colors";

const AgenciesMenu = ({ isAllExpanded, onToggleAll, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef();

  useEffect(() => {
    if (!isOpen) return;
    const closeOnOutsideClick = (event) => {
      if (!containerRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", closeOnOutsideClick);
    return () => document.removeEventListener("click", closeOnOutsideClick);
  }, [isOpen]);

  return (
    <Box
      ref={containerRef}
      padding="0"
      extraStyles="position: relative; display: inline-flex;"
    >
      <ButtonWithAction
        action={() => setIsOpen((prev) => !prev)}
        variant="smallGhost"
        contentOverride
        extraStyles={`
          padding: 0;
          min-width: auto;
          height: auto;
          margin: 0;
          line-height: 0;
          border-radius: 6px;
          svg {
            width: 14px;
            height: 21px;
          }
          svg path:not(:first-of-type) {
            fill: ${TEXT_PRIMARY};
          }
          &:hover {
            background-color: ${HOVER_GREY};
          }
        `}
      >
        <KebabMenuIcon />
        <Box padding="0" srOnly>
          <Text>Agency list options</Text>
        </Box>
      </ButtonWithAction>
      {isOpen && (
        <Box
          background={WHITE}
          borderRadius="6px"
          border={`1px solid ${BORDER_PRIMARY}`}
          boxShadow="0px 4px 16px rgba(41, 42, 51, 0.12);"
          padding="0"
          extraStyles="position: absolute; top: 28px; right: 0; z-index: 1000; white-space: nowrap; overflow: hidden;"
        >
          <ButtonWithAction
            text={isAllExpanded ? "Collapse All" : "Expand All"}
            action={() => {
              onToggleAll();
              setIsOpen(false);
            }}
            disabled={disabled}
            variant="smallGhost"
            dataQa={isAllExpanded ? "Collapse all agencies" : "Expand all agencies"}
            extraStyles={`
              width: 100%;
              margin: 0;
              padding: 6px 0;
              border-radius: 0;
              &:hover {
                background-color: ${HOVER_GREY};
              }
            `}
          />
        </Box>
      )}
    </Box>
  );
};

export default AgenciesMenu;
